<script>
  import { onMount, onDestroy } from "svelte";

  let fadedOut = true;

  // Effectively changes the opacity of the page contents
  const fade = (out = false) => {
    setTimeout(() => (fadedOut = out), 100);
  };

  onMount(() => fade());

  onDestroy(() => fade(true));
</script>

<style>
  .page-container {
    /* background: red; */
    height: 100%;
    position: absolute;
    width: 100%;
    /* Transition */
    transition: opacity 0.2s;
    -webkit-transition: opacity 0.2s;
    -moz-transition: opacity 0.2s;
  }

  .page-container.fadedOut {
    opacity: 0;
  }
</style>

<div class="full-page">
  <div class="page-container" class:fadedOut>
    <slot />
  </div>
</div>
